import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from '@material-ui/core/Modal';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import { toast } from 'react-toastify';

import Button from '~/components/Button';
import Paper from '~/components/Paper';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import Request from '~/providers/Request';

import useStyles from './styles';
import { FormControl, MenuItem, Select, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { ArrowDropDown } from '@material-ui/icons';
function ModalCategory(props) {
  const { modal, onClose, category, isEdit, selectedLanguage } = props;
  const { t } = useTranslation();
  const trAttr = (attr) => t(`faq.attributes.${attr}`);

  const initialState = {
    id: '',
    name: '',
    sorter: 0,
    language_id: '1',
  };
  const [values, setValues] = useState(initialState);

  const classes = useStyles();

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  useEffect(() => {
    setValues({
      id: category.id ? category.id : '',
      name: category.name ? category.name : '',
      sorter: category.sorter ? category.sorter : 0,
      language_id: category.language_id
        ? category.language_id
        : values.language_id,
    });

    if (isEdit) {
      setValues({
        id: category.id ? category.id : '',
        name: category.name ? category.name : '',
        sorter: category.sorter ? category.sorter : 0,
        language_id: selectedLanguage,
      });
    }
  }, [category, selectedLanguage]);

  async function saveAction() {
    const data = {
      attributes: {
        name: values.name,
        sorter: values.sorter,
        language_id: values.language_id,
      },
    };
    if (!isEdit) {
      try {
        await Request.post(
          '/admin/faq/categories',
          { data },
          {},
          { controller: 'faq' }
        );
        onClose();
        toast.success(t('faq.extras.save_category'));
        setValues(initialState);
      } catch (e) {
        console.log(e);
      }
    } else {
      try {
        const idCat = values.id ? values.id : category.id;
        await Request.put(
          `/admin/faq/categories/${idCat}`,
          { data },
          {},
          { controller: 'faq' }
        );
        onClose();
        toast.success(t('faq.extras.edit_category'));
      } catch (e) {
        console.log(e);
      }
    }
  }

  function handleClose() {
    onClose();
  }
  return (
    <Modal open={modal} onClose={handleClose}>
      <div className={classes.root}>
        <Paper
          classes={{
            root: classes.paper,
          }}
          Icon={QuestionAnswerIcon}
          iconColor="blue"
          title={isEdit ? category.name : t('faq.extras.category_new')}
          actions={
            <IconButton onClick={handleClose}>
              <Icon>clear</Icon>
            </IconButton>
          }
        >
          <Grid style={{ marginTop: 15 }} container spacing={2}>
            <Grid item xs={2} md={2}>
              <Typography align="left" variant="subtitle1">
                {trAttr('name')}
              </Typography>
            </Grid>
            <Grid item xs={12} md={10}>
              <TextField
                id="name"
                name="name"
                fullWidth
                value={values.name}
                onChange={handleChange('name')}
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={2} md={2}>
              <Typography align="left" variant="subtitle1">
                {trAttr('sorter')}
              </Typography>
            </Grid>
            <Grid item xs={12} md={10}>
              <TextField
                id="sorter"
                fullWidth
                type="number"
                value={values.sorter}
                onChange={handleChange('sorter')}
                InputLabelProps={{
                  shrink: true,
                }}
                name="sorter"
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={2} md={2}>
              <Typography align="left" variant="subtitle1">
                Idioma
              </Typography>
            </Grid>
            <Grid item xs={12} md={10}>
              <FormControl fullWidth variant="outlined">
                <Select
                  id="idioma"
                  value={values.language_id}
                  fullWidth
                  onChange={handleChange('language_id')}
                  IconComponent={ArrowDropDown}
                >
                  <MenuItem value={'1'}>Português</MenuItem>
                  <MenuItem value={'2'}>English</MenuItem>
                  <MenuItem value={'3'}>Españhol</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <div
            style={{ marginTop: 40, textAlign: 'right', borderColor: 'black' }}
          >
            <hr />
            <Button
              variant="contained"
              color="grey"
              onClick={handleClose}
              className={classes.button}
            >
              {t('form-cancel')}
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={saveAction}
              className={classes.button}
            >
              {t('form-submit')}
            </Button>
          </div>
        </Paper>
      </div>
    </Modal>
  );
}

ModalCategory.propTypes = {
  modal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  category: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default ModalCategory;
